var _defs, _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "stars_svg__Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.59 89.61"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".stars_svg__cls-3{stroke:#000;stroke-linejoin:round;stroke-width:4px;fill:#fff}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.98,
    cy: 44.81,
    r: 44.81,
    fill: "#fedf00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stars_svg__cls-3",
    d: "M23.51 62.13l-13.16 7.04 2.42-14.73L2 44.09l14.76-2.25 6.51-13.44 6.71 13.35 14.79 2.04-10.62 10.5 2.63 14.7-13.27-6.86zM96.34 62.13l-13.17 7.04 2.42-14.73-10.77-10.35 14.76-2.25 6.51-13.44 6.71 13.35 14.79 2.04-10.62 10.5 2.63 14.7-13.26-6.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 4,
    fill: "#239ed4",
    strokeLinecap: "round",
    d: "M60.16 63.4l-18.53 9.91 3.41-20.73-15.15-14.55 20.77-3.17 9.16-18.9 9.43 18.77 20.81 2.87-14.94 14.77 3.7 20.68-18.66-9.65z"
  })));
}

export default SvgStars;